// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import { productHasPrice } from "@store/Framework/Store/Data/Products/ProductsSelectors";

export default (overridenProduct?: ProductContextModel | CartLineModel) => {
    const { product, productInfo } = useProductContext();
    const hasPrice = productHasPrice(productInfo);

    if (overridenProduct) {
        return (
            hasPrice ||
            ("product" in overridenProduct
                ? overridenProduct.product.allowZeroPricing
                : overridenProduct.allowZeroPricing)
        );
    }

    return (
        hasPrice ||
        product.allowZeroPricing ||
        (productInfo?.pricing?.regularPrice && productInfo?.pricing?.regularPrice >= 0)
    );
};
